import React, { useState } from "react";
import { Sheet } from 'react-modal-sheet';
import BasicPanel from "../../components/panels/basicPanel/basicPanel";
import BasicInput from "../../components/inputs/basicInput/basicInput";
import Btn from "../../components/Btn/Btn";
import './botRaitingPanel.css';
import StepsHeader from "./utils/stepsHeader";
import { useMessenger } from "../../context/messengerContext";
import { useTranslation } from "react-i18next";

const STAR_ICON = (
  <svg width="32" height="29" viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 0L21.1725 8.88065L31.2169 11.0557L24.3693 18.7193L25.4046 28.9443L16 24.8L6.59544 28.9443L7.6307 18.7193L0.783095 11.0557L10.8275 8.88065L16 0Z" fill="url(#paint0_linear_1_1704)"/>
    <defs>
      <linearGradient id="paint0_linear_1_1704" x1="0" y1="16" x2="32" y2="16" gradientUnits="userSpaceOnUse">
        <stop stopColor="#55E5FF"/>
        <stop offset="1" stopColor="#5DFF66"/>
      </linearGradient>
    </defs>
  </svg>
);

const STAR_ICON_EMPTY = (
    <svg width="32" height="29" viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 0L21.1725 8.88065L31.2169 11.0557L24.3693 18.7193L25.4046 28.9443L16 24.8L6.59544 28.9443L7.6307 18.7193L0.783095 11.0557L10.8275 8.88065L16 0Z" fill="#E0E0E0"/>
    </svg>
);

const CustomRate = ({ value, onChange, max = 5 }) => {
    return (
        <div style={{ display: 'flex', gap: '8px', cursor: 'pointer' }}>
            {[...Array(max)].map((_, index) => {
                const ratingValue = index + 1;
                return (
                    <div
                        key={ratingValue}
                        onClick={() => onChange(ratingValue)}
                        onTouchEnd={(e) => {
                            e.preventDefault();
                            onChange(ratingValue);
                        }}
                    >
                        {ratingValue <= value ? STAR_ICON : STAR_ICON_EMPTY}
                    </div>
                );
            })}
        </div>
    );
};

const FeedbackPanel = ({
  rating, setRating,
  comment, setComment,
  ratingError, setRatingError,
  commentError, setCommentError,
  isSheetOpen, setIsSheetOpen
}) => {
  const { close } = useMessenger();
  const { t } = useTranslation('basic');
  const handleSubmit = () => {
    const isRatingEmpty = rating === 0;
    const isLowRating = rating > 0 && rating <= 3;
    const isCommentEmpty = comment.trim() === "";

    setRatingError(isRatingEmpty);
    setCommentError((isRatingEmpty || isLowRating) && isCommentEmpty);
    if (isRatingEmpty || (isLowRating && isCommentEmpty)) return;
    console.log("Оценка:", rating);
    console.log("Комментарий:", comment);
    setIsSheetOpen(true);
  };

  return (
    <>
      <StepsHeader />
      <div style={{
        paddingInline: "1rem",
        paddingTop: "1.5rem"
      }}>
        <BasicPanel>
          <div className="feedback-panel">
            <div className="rating-label paragraph-14R">{t("rating_label")}</div>
            <div className="rate">
              <CustomRate
                value={rating}
                onChange={(val) => {
                  setRating(val);
                  if (val > 0) setRatingError(false);
                  if (val > 3 || (val > 0 && comment.trim() !== "")) setCommentError(false);
                }}
              />
              {ratingError && (
                <div className="error-text">{t("select_rating")}</div>
              )}
            </div>
            <div className="comment-input-wrapper">
              <BasicInput
                flexible
                textarea
                placeholder={t("comment_placeholder")}
                value={comment}
                onChange={(val) => {
                  setComment(val);
                  if (commentError && val.trim() !== "") {
                    setCommentError(false);
                  }
                }}
                error={commentError}
              />
              {commentError && (
                <div className="error-text">{t("fill_required_field")}</div>
              )}
            </div>
            <div className="submit-btn-wrapper">
              <Btn 
                onClick={handleSubmit} 
                width="100%" 
                text={t("submit_rating")}
                className="custom-btn"
              />
            </div>
          </div>
          <Sheet isOpen={isSheetOpen} onClose={() => setIsSheetOpen(false)}>
            <Sheet.Container>
              <Sheet.Content>
                <div className="modal-content">
                  <div className="background-blur"></div> {/* Градиентный фон */}
                  <div className="star-wrapper">
                    {STAR_ICON}
                  </div>
                  <h2 className="heading-h4 star_svg">{t("thanks_for_review")}</h2>
                  <Btn
                    onClick={() => {
                      setIsSheetOpen(false);
                      close();
                    }}
                    width="100%"
                    text={t("ok_button")}
                  />
                </div>
              </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop />
          </Sheet>
        </BasicPanel>
      </div>
    </>
  );
};

const FeedbackPanelWrapper = () => {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [isSheetOpen, setIsSheetOpen] = useState(false);
  const [ratingError, setRatingError] = useState(false);
  const [commentError, setCommentError] = useState(false);

  return (
    <FeedbackPanel
      rating={rating}
      setRating={setRating}
      comment={comment}
      setComment={setComment}
      ratingError={ratingError}
      setRatingError={setRatingError}
      commentError={commentError}
      setCommentError={setCommentError}
      isSheetOpen={isSheetOpen}
      setIsSheetOpen={setIsSheetOpen}
    />
  );
};

export default FeedbackPanelWrapper;
